(ns common.schema.entities.oppo.permissions
  (:require [common.features.plan :as plan]
            [common.modules :as modules]
            [common.schema.entities.permissions :as entity-permissions]))

(defn read-permissions?
  [{:keys [account-current-permissions tenant role tenant-plan target entity]}]
  (or
   ;; A buy-side guest may read only the single deal shared with them.
   (and (= role :role/guest-buy-side)
        target
        (= (:db/id entity) (:db/id target)))
   ;; Everyone else needs the module AND access to this deal's specific pipeline.
   ;; The pipeline gate matches the exit/sales/fundraising read checks and the
   ;; sync-layer pipeline filter; dropping it (as an earlier migration did) let
   ;; any dealflow-module user read deals in pipelines they cannot access —
   ;; invisible in the web app (its sync path re-filters) but exposed over MCP,
   ;; whose read authorization relies solely on this check.
   (and (plan/available :feature/dealflow tenant role tenant-plan)
        (modules/has-module? account-current-permissions :module/dealflow)
        (contains? (:account-access-to-pipelines account-current-permissions)
                   (-> entity :oppo/pipeline :db/id)))))

(defn disable-permissions?
  [ctx]
  (entity-permissions/disable-when-no-write-permission ctx))
